(function (angular) {

    'use strict';

    angular.module('app.purchase')
        .controller('app.purchase.InviteToPlanResponseController',
            [
                '$uibModalInstance',
                '$timeout',
                function ($uibModalInstance, $timeout){
                    $timeout(function timerComplete() {
                        $uibModalInstance.dismiss();
                    }, 2000);
                }
            ]);
})(angular);